import { render } from "./PageSignInFailed.vue?vue&type=template&id=40465ae6"
import script from "./PageSignInFailed.vue?vue&type=script&lang=js"
export * from "./PageSignInFailed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\raubart\\Desktop\\loop\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__